import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { ExternalScrollbarComponent } from "./external-scrollbar.component";

@NgModule({
  declarations: [ExternalScrollbarComponent],
  imports: [CommonModule, TranslateModule],
  exports: [ExternalScrollbarComponent],
})
export class ExternalScrollbarModule {}
